export function initHistoryPopover(): void {
  if (document.body.dataset.histPopBound === "1") return;
  document.body.dataset.histPopBound = "1";

  const closeAll = () =>
    document
      .querySelectorAll<HTMLElement>("[data-history-popover].open")
      .forEach((p) => p.classList.remove("open"));

  const place = (pop: HTMLElement, anchor: HTMLElement) => {
    const r = anchor.getBoundingClientRect();
    const w = pop.offsetWidth || 290;
    const h = pop.offsetHeight || 180;
    const left = Math.min(r.left, window.innerWidth - w - 10);
    let top = r.bottom + 8;
    if (top + h > window.innerHeight) top = Math.max(10, r.top - 8 - h);
    pop.style.left = Math.max(10, left) + "px";
    pop.style.top = top + "px";
  };

  document.addEventListener("click", (e) => {
    const btn = (e.target as HTMLElement).closest<HTMLElement>("[data-history-toggle]");
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      const id = btn.dataset.historyToggle;
      const pop = document.querySelector<HTMLElement>(`[data-history-popover="${id}"]`);
      if (!pop) return;
      const willOpen = !pop.classList.contains("open");
      closeAll();
      if (willOpen) {
        pop.classList.add("open"); // display:block first so offset dimensions are real
        place(pop, btn);
      }
      return;
    }
    // Clicks inside the popover keep it open; anything else closes it.
    if (!(e.target as HTMLElement).closest("[data-history-popover]")) closeAll();
  });

  window.addEventListener("resize", closeAll);
  document.addEventListener("scroll", (e) => {
    if (!(e.target instanceof Element && e.target.closest("[data-history-popover]"))) closeAll();
  }, true);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAll();
    if (e.key !== "Enter" && e.key !== " ") return;
    const toggle = (e.target as HTMLElement).closest<HTMLElement>("[data-history-toggle]");
    if (toggle && toggle.tagName !== "BUTTON") {
      e.preventDefault();
      toggle.click();
    }
  });
}
